import { h, Component } from "preact";

import arrowLeftIcon from "../assets/images/icon-arrow-left.svg";

const backStyles = {
  background: `url(${arrowLeftIcon}) no-repeat left center`,
  border: "none",
  padding: "0 0 0 24px",
  textDecoration: "none",
  color: "#000",
  cursor: "pointer",
  marginRight: "0.4rem"
};

class BackButton extends Component {
  constructor() {
    super();
    this.state = { isInIframe: false };
  }

  componentDidMount() {
    this.setState({ isInIframe: this.inIframe() });
  }

  inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
  render() {
    const { isInIframe } = this.state;
    if (!isInIframe) {
      return null;
    }
    return (
      <a
        style={backStyles}
        aria-label="Back"
        onClick={() => {
          window.history.back();
        }}
      >
        Back
      </a>
    );
  }
}
export default BackButton;



// WEBPACK FOOTER //
// ./components/BackButton.js